module.exports = __webpack_public_path__ + "static/media/magic.64425b06.svg";